function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { UnstyledTable } from "../../../unstyled/table/base/UnstyledTable";
import "./table.css";

/*
    Returns a component to wrap the sections of the table like header and body

    props
        (jsx, optional)  beforeTableContent  Elements that are rendered above the table
        (jsx, optional)  afterTableContent   Elements that are rendered below the table
        (jsx, optional)  children            The sections of the table like header and body
                                                - All props sent to the Table and passed down to each child
*/

const Table = ({
  classPrepend = "styled",
  columns = [],
  beforeTableContent = null,
  afterTableContent = null,
  children,
  expandedRowRender = null,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(UnstyledTable, _extends({
    classPrepend: classPrepend,
    columns: columns,
    beforeTableContent: beforeTableContent,
    afterTableContent: afterTableContent,
    expandedRowRender: expandedRowRender
  }, rest), children);
};
export { Table };